<template>
	<b-card title="Audio" class="mb-3">
		<volume-slider v-model="settings.volume" class="mb-3" />
		<slider-form-group label="Compression" :min="0" :max="100" :step="1" v-model="settings.compressionAmount" class="mb-3">
			<span class="text-muted">{{ settings.compressionAmount > 0 ? settings.compressionAmount : 'Off' }}</span>
		</slider-form-group>
		<b-form-checkbox switch v-model="settings.normalizeVolume">Normalize volume</b-form-checkbox>
	</b-card>
</template>

<script>
import SliderFormGroup from '@/components/SliderFormGroup.vue';
import VolumeSlider from '@/components/VolumeSlider.vue';

export default {
	components: { SliderFormGroup, VolumeSlider },
	props: {
		settings: Object,
	},
};
</script>
